import _regeneratorRuntime from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { deferrable } from "./deferrable";
import * as JWT from "./jwt";
import { OidcClient } from "./OidcClient";
import { createGrant } from "./OidcGrants";
import { RedirectTransport } from "./OidcTransports";
export var UserManager =
/*#__PURE__*/
function () {
  function UserManager() {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, UserManager);

    this.client_type = settings.client_type;
    this.claims = ["idp", "sub", "email"].concat(settings.claims || []);
    this.clock_skew = Math.max(Number(settings.clock_skew), 0) || 120;
    this.transport = settings.transport && "signin" in settings.transport ? settings.transport : new RedirectTransport(settings.transport);
    this.oidcClient = settings.oidcClient || new OidcClient(settings);
    this.userInfo = deferrable().resolve(UserManager.Anonymous);
  }

  _createClass(UserManager, [{
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var exchange_access_token,
            userInfo,
            _userInfo,
            _userInfo$tokens,
            _userInfo$tokens$refr,
            refresh_token,
            _userInfo$tokens$acce,
            access_token,
            _userInfo$tokens$exp,
            expired_at,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                exchange_access_token = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
                _context.next = 3;
                return this.userInfo.promise;

              case 3:
                userInfo = _context.sent;
                _userInfo = userInfo, _userInfo$tokens = _userInfo.tokens;
                _userInfo$tokens = _userInfo$tokens === void 0 ? {} : _userInfo$tokens;
                _userInfo$tokens$refr = _userInfo$tokens.refresh_token, refresh_token = _userInfo$tokens$refr === void 0 ? 0 : _userInfo$tokens$refr, _userInfo$tokens$acce = _userInfo$tokens.access_token, access_token = _userInfo$tokens$acce === void 0 ? 0 : _userInfo$tokens$acce, _userInfo$tokens$exp = _userInfo$tokens.exp, expired_at = _userInfo$tokens$exp === void 0 ? 0 : _userInfo$tokens$exp;

                if (!refresh_token) {
                  _context.next = 14;
                  break;
                }

                if (!(
                /* forced! */
                exchange_access_token && exchange_access_token === access_token ||
                /* expired */
                Date.now() - expired_at > 0)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 11;
                return this.lockUserInfo(function () {
                  return _this.transport.refresh(_this.oidcClient, refresh_token);
                }, userInfo);

              case 11:
                userInfo = _context.sent;

              case 12:
                _context.next = 16;
                break;

              case 14:
                if (!exchange_access_token) {
                  _context.next = 16;
                  break;
                }

                throw new Error("Unable to refresh the user tokens: refresh_token is missing.");

              case 16:
                return _context.abrupt("return", userInfo);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }()
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      var exchange_access_token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.getUserInfo(exchange_access_token).then(function (userInfo) {
        var tokens = userInfo.tokens;
        return tokens && tokens.access_token;
      });
    }
  }, {
    key: "signin",
    value: function signin() {
      var _this2 = this;

      return this.lockUserInfo(function () {
        var grantFlow = createGrant(_this2.client_type);
        return _this2.transport.signin(_this2.oidcClient, grantFlow);
      });
    }
  }, {
    key: "signout",
    value: function () {
      var _signout = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(redirect_uri) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.lockUserInfo(function (userInfo) {
                  var _userInfo$tokens2 = userInfo.tokens;
                  _userInfo$tokens2 = _userInfo$tokens2 === void 0 ? {} : _userInfo$tokens2;
                  var _userInfo$tokens2$id_ = _userInfo$tokens2.id_token,
                      id_token = _userInfo$tokens2$id_ === void 0 ? null : _userInfo$tokens2$id_;
                  return _this3.transport.signout(_this3.oidcClient, id_token, redirect_uri);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signout(_x) {
        return _signout.apply(this, arguments);
      }

      return signout;
    }()
  }, {
    key: "lockUserInfo",
    value: function () {
      var _lockUserInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(fetchToken) {
        var _this4 = this;

        var userInfo,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userInfo = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
                _context4.t0 = userInfo;

                if (_context4.t0) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 5;
                return this.userInfo.promise;

              case 5:
                _context4.t0 = _context4.sent;

              case 6:
                userInfo = _context4.t0;
                this.userInfo = deferrable();
                return _context4.abrupt("return", new Promise(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3(resolve, reject) {
                    var tokenResponse, tokens;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return fetchToken(userInfo);

                          case 3:
                            tokenResponse = _context3.sent;
                            userInfo = _this4.buildUserInfo(tokenResponse, userInfo);

                            _this4.userInfo.resolve(userInfo);

                            resolve(userInfo);
                            _context3.next = 14;
                            break;

                          case 9:
                            _context3.prev = 9;
                            _context3.t0 = _context3["catch"](0);

                            if ("message" in _context3.t0 && _context3.t0["message"].indexOf("invalid_grant") > -1) {
                              tokens = userInfo.tokens;

                              if ("refresh_token" in tokens) {
                                tokens["refresh_token"] = null; // to prevent the rotation because it has expired

                                _context3.t0 = new Error("Unable to refresh the user tokens: refresh_token has expired.");
                              }
                            }

                            _this4.userInfo.resolve(userInfo);

                            reject(_context3.t0);

                          case 14:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[0, 9]]);
                  }));

                  return function (_x3, _x4) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function lockUserInfo(_x2) {
        return _lockUserInfo.apply(this, arguments);
      }

      return lockUserInfo;
    }()
  }, {
    key: "buildUserInfo",
    value: function buildUserInfo(tokenResponse) {
      var userInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var newTokens = tokenResponse;

      if (newTokens) {
        if ("tokens" in userInfo) {
          var oldTokens = userInfo.tokens;
          var reused = {
            id_token: newTokens.id_token || oldTokens.id_token,
            refresh_token: newTokens.refresh_token || oldTokens.refresh_token
          };
          newTokens = Object.assign({}, oldTokens, newTokens, reused);
        }

        var issued_at = Date.now();
        newTokens["iat"] = issued_at;
        newTokens["exp"] = getExpiredAt(issued_at, newTokens.expires_in, this.clock_skew);
        var claims = Object.assign({}, JWT.payload(newTokens.id_token), JWT.payload(newTokens.access_token));
        userInfo = this.claims.reduce(function (profile, claim) {
          return profile[claim] = claims[claim], profile;
        }, {
          tokens: newTokens
        });
        return userInfo;
      }

      return UserManager.Anonymous;
    }
  }]);

  return UserManager;
}();
UserManager.Anonymous = Object.freeze({});
export function getExpiredAt(current_time, expires_in, clock_skew) {
  return milliseconds(seconds(current_time) + expires_in - clock_skew);
}

function seconds(ms) {
  return Math.trunc(ms / 1000);
}

function milliseconds(s) {
  return s * 1000;
}